<template>
  <div>
    <v-dialog v-model="dialog" width="80%">
      <template v-slot:activator="{ on, attrs }">
        <v-card class="book-title" height="200" v-bind="attrs" v-on="on">
          {{ bookInfo.title }}
        </v-card>
      </template>

      <v-card class="book-detail">
        <v-img
          v-if="bookInfo.cover"
          height="250"
          v-bind:src="bookInfo.cover"
          contain
        >
        </v-img>
        <v-card-title class="text-h6 lighten-2">
          {{ bookInfo.title }}
        </v-card-title>

        <v-card-text>
          {{ bookInfo.author }}<br>
          {{ bookInfo.publisher }}
        </v-card-text>

        <v-card-text> </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> 閉じる </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    bookInfo: Object,
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped>
.book-title {
  text-orientation: upright;
  font-size: 0.8rem;
}
.book-detail,
.v-card__title,
.v-card__text {
  font-family: "Zen Old Mincho" !important;
}
</style>
